import React from "react";
import medical from "../assets/updated-image-new.jpg";

const CarryingExtraWeight = () => {
  return (
    <div>

      <h1 className="text-2xl font-bold text-gray-800 mb-4">  
        {"Carrying Extra Weight Can Impact More Than Just How You Feel Physically"}
      </h1>

      <div className="mb-4">  
        
        <img   
          src={medical} 
          alt="Dr K JFK medical"
          className="w-full rounded-3xl border border-gray-100"  
          draggable="false"   
        />

        <div className="bg-[#fff3c4] border border-[#fdcc5e] mt-3 p-2 text-[#303030] italic text-lg"> 
          {" Dr. Kandace and her team of metabolic specialists spent years searching for ways to help people feel energized, lighter, and in control of their health. And this year, that search led to a powerful discovery centered around gut balance."} 
        </div>

      </div> 
      <div className="space-y-4 text-[#303030]"> 
        <p> 
          {"One evening, while reviewing studies on microbiome health and metabolism, Dr. Kandace came across a new piece of research that connected gut bacteria to long-term weight and digestive challenges."}
        </p>  
       
      </div>  
    </div> 
  ); 
};  

export default CarryingExtraWeight;
